import React, { Fragment } from "react";
import { connect } from "react-redux";
// eslint-disable-next-line object-curly-newline
import { CardTitle, Modal, Button, ModalBody, ModalHeader } from "reactstrap";
import { HIDE_JOU_TRADING } from "common/data/jourenykeys";
import { CloseButton } from "react-bootstrap";

const StartTradingModal = (props) => {
  const hideModal = localStorage.getItem(HIDE_JOU_TRADING) === "true";

  return (
    <Fragment>
      <Modal
        isOpen={props.show && !hideModal}
        toggle={props.toggle}
        centered={true}
        //   size="lg"
        className="custom-modal"
      >
        <ModalHeader className="d-flex flex-column gap-3">
          <CloseButton
            onClick={() => props.toggle()}
            style={{
              alignSelf: "flex-end",
              position: "absolute",
              right: 10,
              top: 10,
            }}
          />
          <div className="text-center">
            <CardTitle className="mb-0 color-primary">{props.t("Start Trading")}</CardTitle>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="text-center">
            <Button
              onClick={props.toggle}
              color="danger"
              className="w-lg waves-effect waves-light m-2"
            >
              {props.t("Skip")}
            </Button>
            <Button
              onClick={() => {
                // check if already on platforms page
                if (props.history.location.pathname === "/platforms") {
                  props.toggle();
                } else {
                  props.toggle();
                  props.history.push("/platforms");
                }
              }}
              color="success"
              className="w-lg waves-effect waves-light m-2"
            >
              {props.t("Start Trading")}
            </Button>
            {/* <Button onClick={()=>{ props.history.push("/quick-buy") }} color="success" className="blue-gradient-color w-lg waves-effect waves-light m-2">
              Start Trading
          </Button> */}
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  profile: (state.Profile && state.Profile.clientData) || {},
});
export default connect(mapStateToProps, null)(StartTradingModal);
